export const TOURNAMENT_LOAD_PLAYERS = 'TOURNAMENT_LOAD_PLAYERS'
export const TOURNAMENT_LOAD_PLAYERS_SUCCESS = 'TOURNAMENT_LOAD_PLAYERS_SUCCESS'
export const TOURNAMENT_LOAD_PLAYERS_FAILURE = 'TOURNAMENT_LOAD_PLAYERS_FAILURE'
export const TOURNAMENT_SET_RESERVE_LIST = 'TOURNAMENT_SET_RESERVE_LIST'
export const TOURNAMENT_SET_PLAYER_POOL = 'TOURNAMENT_SET_PLAYER_POOL'
export const TOURNAMENT_TEAMS = 'TOURNAMENT_TEAMS'
export const TOURNAMENT_TEAMS_SUCCESS = 'TOURNAMENT_TEAMS_SUCCESS'
export const TOURNAMENT_TEAMS_FAILURE = 'TOURNAMENT_TEAMS_FAILURE'
